<template>
  <div class="failure-page">
    <div class="container">
      <div class="icon-wrapper">
        <font-awesome-icon :icon="['fas', 'times']" class="failure-icon" />
      </div>
      <h1>Payment Failed</h1>
      <p>
        We're sorry, there was an issue processing your payment. Please check your payment details and try again.
        If the problem persists, feel free to contact our support team for assistance.
      </p>
      <div class="actions">
        <router-link to="/" class="button primary">Try Again</router-link>
        <router-link to="/contact-us" class="button secondary">Contact Support</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'FailurePage',
  components: { FontAwesomeIcon }
};
</script>

<style scoped>
.failure-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
  background-color: var(--alt-bg);
}

.container {
  max-width: 600px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.icon-wrapper {
  margin-bottom: 20px;
}

.failure-icon {
  font-size: 4rem;
  color: var(--hollywood-cerise);
}

h1 {
  color: var(--hollywood-cerise);
  margin-bottom: 20px;
  font-size: 2rem;
}

p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: var(--rich-black);
  margin-bottom: 30px;
}

.actions {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
}

a.button {
  text-decoration: none;
}

/* Primary CTA */
.button.primary {
  background-color: var(--hollywood-cerise);
  color: white;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 1rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}
.button.primary:hover {
  background-color: var(--violet-lush);
}

/* Secondary CTA */
.button.secondary {
  background-color: var(--powder-blue);
  color: var(--rich-black);
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 1rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}
.button.secondary:hover {
  background-color: var(--light-pink);
}

/* Mobile adjustments */
@media (max-width: 480px) {
  .container {
    padding: 24px;
  }

  h1 {
    font-size: 1.8rem;
  }

  p {
    font-size: 1rem;
  }

  .button.primary,
  .button.secondary {
    width: 100%;
    font-size: 0.95rem;
    padding: 10px 20px;
  }

  .actions {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
